import { TwoUpEventType, WorkRestEventType,
    TwoUpWorkRestOption, WorkRestOption, EventRecordStatus, EWDOrigin } from './common.enum';
import { Driver } from './index';

export class WorkDiary {
    EWDRecords: EWDRecord[];
    WorkRestRecords: EWDRecord[];
    AuthorisedOfficerAnnotations: AuthorisedOfficerAnnotation[];
    Comments: Comment[];
    DriverInfo: DriverInfo;
    NumberPlateEvents: NumberPlateEvent[];
    TwoUpRecords: EWDRecord[];
    WorkRestEvents: WorkRestEvent[];
    WorkRestOptionEvents: WorkRestOptionEvent[];
    Location: Location;
    WorkDiaryCharts: WorkDiaryChart[];
    PriorWorkRestEvent: EWDRecord;
    PriorWorkRestOptionEvent: EWDRecord;
    PriorNumberPlateEvent: EWDRecord;
    PriorTwoUpEvent: EWDRecord;
}

export class WorkDiaryChart {
    LocalTimestamp: string;
    AnnotationsChartData: ChartHourData[];
    CommentsChartData: ChartHourData[];
    LocationChartData: ChartHourData[];
    TwoUpEventsChartData: ChartTimeData[];
    WorkRestEventsChartData: ChartTimeData[];
    NoAccessPeriods: ChartTimePeriod[];
    TotalWorkMins: string;
    TotalRestMins: string;
    BreachesChartData: ChartHourData[];
}

export class ChartTimePeriod {
    StartTime: string;
    EndTime: string;
    StartMins: number;
    EndMins: number;
}

export class ChartTimeData {
    ServerSyncId: number;
    StartTime: string;
    EndTime: string;
    StartMins: number;
    EndMins: number;
    LocalStartTime: string;
    LocalEndTime: string;
    PreviousStatus: number;
    Status: number;
}

export class ChartHourData {
    ServerSyncId: number;
    StartMins: number;
    Status: number;
    ChartHourText: string;
}

export class EWDRecord {
    ServerSyncId: number;
    DeviceSyncId: number;
    SerialNumber: string;
    EventRecordStatus: EventRecordStatus;
    Timestamp: string;
    EventTimestamp: string;
    LocalEventTimestamp: string;
    LocalTimestamp: string;
    Origin: EWDOrigin;
    AuthorisedOfficerAnnotation: AuthorisedOfficerAnnotation;
    Comment: Comment;
    Username: string;
    DriverInfo: DriverInfo;
    NumberPlateEvent: NumberPlateEvent;
    TwoUpEvent: TwoUpEvent;
    WorkRestEvent: WorkRestEvent;
    WorkRestOptionEvent: WorkRestOptionEvent;
    IsEditable: boolean;
    RowState: number;
    IsCertified: boolean;
    RecordGroupIdentifier: string;
}

export class AuthorisedOfficerAnnotation {
    ServerSyncId: number;
    Annotation: string;
    FlaggedTime: string;
    InterceptTime: string;
    Location: Location;
    TechnologyProviderId: string;
    Timestamp: string;
    LocalFlaggedTime: string;
    LocalInterceptTime: string;
    Origin: EWDOrigin;
}

export class Comment {
    Comment: string;
    Timestamp: string;
}

export class DriverInfo {
    DriverId: string;
    DriverLicenceIssued: string;
    DriverLicenceNumber: string;
    DriverName: string;
    DriverTimezone: string;
    BaseState: string;
    EWDUnifiedMode: boolean;
    EWDLogoutSynchronisation: boolean;

    constructor(driver: Driver) {
        this.DriverId = driver.UserName;
        this.DriverLicenceIssued = driver.LicenceState;
        this.DriverLicenceNumber = driver.LicenceNumber;
        this.DriverName = driver.FullName;
        this.BaseState = driver.BaseState;
        this.EWDUnifiedMode = driver.EWDUnifiedMode;
        this.EWDLogoutSynchronisation = driver.EWDLogoutSynchronisation;
    }
}

export class NumberPlateEvent {
    ServerSyncId: number;
    NewNumberPlate: string;
    LocalEventTime: string;
    Timestamp: string;
    Origin: EWDOrigin;
}

export class TwoUpDriver extends DriverInfo {
    workRestOption: TwoUpWorkRestOption;
    providerId: number;
    wwdSecurityNumber: string;
    wwdPageNumber: string;
    providerType: string;

}

export class TwoUpEvent {
    EventType: TwoUpEventType;
    Timestamp: string;
    TwoUpDriver: TwoUpDriver;
    TwoUpDriverId: string;
}

export class WorkRestEvent {
    EventType: WorkRestEventType;
    HistoricData: Boolean;
    Location: Location;
    Odometer: number;
    StartTime: string;
    Timestamp: string;
}

export class WorkRestOptionEvent {
    afmAccreditationNumber: string;
    Timestamp: string;
    WorkRestOption: WorkRestOption
}

export class Location {
    Latitude: number;
    Longitude: number;
    Name: string;
}
